export default __webpack_public_path__ + "static/media/hamburgermenu.246a144f.svg";